module.exports = __webpack_public_path__ + "img/jl.03564ec6.png";